// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"32f7ac0e","990":"4a2357b6"}[chunkId] + ".chunk.js";
};